export default function Hero() {
  const scrollToWorks = () => {
    document.getElementById('works')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="top" className="pf-hero">
      <div className="pf-hero__bg" />
      <div className="pf-hero__grain" />

      <div className="pf-hero__content">
        <p className="pf-hero__eyebrow">書家 / CALLIGRAPHER</p>
        <h1 className="pf-hero__title">
          <span className="pf-hero__title-jp">梅谷彩雲</span>
          <span className="pf-hero__title-en">UMETANI SAIUN</span>
        </h1>
        <p className="pf-hero__lead">
          伝統書道を、現代へ。<br />
          一筆に込めた静けさと力強さを、虹嶺庵から。
        </p>

        <button className="pf-hero__cta" onClick={scrollToWorks}>
          WORKS を見る
        </button>
      </div>

      <button className="pf-hero__scroll" onClick={scrollToWorks} aria-label="scroll down">
        <span className="pf-hero__scroll-line" />
        SCROLL
      </button>
    </section>
  );
}
